var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDiffInCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85355 0.85355C7.04882 0.658288 7.04882 0.341706 6.85355 0.146444C6.65829 -0.0488166 6.34139 -0.0484965 6.14613 0.14676C5.32008 0.96531 4.53135 1.86608 3.51895 2.46161C3.50134 2.47178 3.49864 2.47196 3.48105 2.46161C2.46853 1.86601 1.67969 0.965104 0.853553 0.146444C0.658291 -0.0488125 0.341707 -0.0488165 0.146447 0.146444C-0.0488155 0.341706 -0.0488155 0.658288 0.146447 0.85355C0.901632 1.60197 1.67138 2.35639 2.51546 3.00568C2.79297 3.21916 3.12787 3.5 3.5 3.5C3.87213 3.5 4.20703 3.21916 4.48454 3.00568C5.32919 2.35596 6.0975 1.60283 6.85355 0.85355Z",
    fill: "#4D0891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDiffInCount);
export default __webpack_public_path__ + "static/media/arrowDiffInCount.1652aec9f7f5d40383c9ac97be089bc5.svg";
export { ForwardRef as ReactComponent };